import React from 'react';
import MagnifierIcon from './icons/MagnifierIcon';

const SearchInput = ({
  value,
  handleInputChange,
  hasResults,
  handleFocus,
  handleBlur,
  searchHint,
  onlyAddress,
  inputRef,
  className = "",
  inputName
}) => (
  <div className="searchInputWrapper">
    { !onlyAddress && (
      <MagnifierIcon style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' }} />
    )}
    <input
      id='address-input'
      className={`searchInput ${className}`}
      style={{
        borderBottomLeftRadius: hasResults ? '0' : '',
        borderBottomRightRadius: hasResults ? '0' : ''
      }}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={searchHint}
      value={value}
      onChange={handleInputChange}
      ref={inputRef}
      name={inputName}
    />
  </div>
);

export default SearchInput;
